import { render, staticRenderFns } from "./NewLeadSamples.vue?vue&type=template&id=73ff967c&"
import script from "./NewLeadSamples.vue?vue&type=script&lang=js&"
export * from "./NewLeadSamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports